module.exports = __webpack_public_path__ + "img/amb-rxgold.58041986.png";